export function prefillEmptySurveyAnswers(surveyAnswers, question) {
    let defaultValue = null;
    if (question.type === 'select') {
        defaultValue = question.options[0].value;
    }
    surveyAnswers[question.id] = defaultValue;
}

export function urlHashToObject(url) {
    const urlObj = new URL(url);
    const params = new URLSearchParams(urlObj.hash.substring(1));
    const obj = {};
    for (const [key, value] of params.entries()) {
        obj[key] = value;
    }
    return obj
}